<template>
  <v-dialog
    v-model="dialog"
    max-width="700"
    @keydown.esc="dialog = false">
    <v-card>
      <v-row wrap>
        <v-col cols="12">
          <m-card title="Detail Organisasi">
            <v-row wrap>
              <v-col cols="12" sm="6" md="6">
                <v-card text color="#009688" flat>
                  <v-img
                    class="white--text"
                    height="250px"
                    src="img/parallax.png"
                  >
                    <v-container fill-height container--fluid>
                      <v-row fill-height>
                        <v-col class="text-center" cols="12" align-end colbox>
                          <v-avatar :size="200" color="grey lighten-4">
                            <img
                              :src="
                                organisasi && organisasi.file_foto
                                  ? organisasi.file_foto
                                  : 'img/organisasi-default.png'
                              "
                              alt="avatar"
                            />
                          </v-avatar>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-img>
                </v-card>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-list class="pt-0">
                  <m-list-tile-info
                    label="Kode Tenant"
                    :value="pVal(organisasi.tenants, 'no_reg')"
                  />
                  <m-list-tile-info
                    label="Kode Organisasi"
                    :value="pVal(organisasi, 'kode_organisasi')"
                  />
                  <m-list-tile-info
                    label="Nama Organisasi"
                    :value="pVal(organisasi, 'nama')"
                  />
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-subtitle
                      >Berakhir Berlangganan</v-list-item-subtitle
                      >
                      <slot name="value">
                        <span class="subtitle-1 font-weight-bold red--text">

                        </span>
                      </slot>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
            <v-row wrap>
              <v-col cols="12" sm="6" md="6" lg="6">
                <v-list>
                  <v-subheader class="title primary--text">Kontak</v-subheader>
                  <v-divider></v-divider>
                  <m-list-tile-info label="Alamat" :value="organisasi.alamat" />
                  <m-list-tile-info
                    label="No. Telepon"
                    :value="organisasi.no_telp"
                  />
                  <m-list-tile-info label="Surel" :value="organisasi.email" />
                  <m-list-tile-info label="Fax" :value="organisasi.fax" />
                </v-list>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6">
                <v-list>
                  <v-subheader class="title primary--text">
                    Informasi Tambahan
                  </v-subheader>
                  <v-divider></v-divider>
                  <span v-for="item of organisasi.atribut" :key="item.key">
                    <m-list-tile-info :label="item.key" :value="item.value" />
                  </span>
                  <span>
                    <m-list-tile-info label="Tanggal Berlaku Awal" :value="organisasi.tgl_berlaku_awal | toSD" />
                    <m-list-tile-info label="Tanggal Berlaku Akhir" :value="organisasi.tgl_berlaku_akhir | toSD" />
                    <m-list-tile-info label="Total Kuota" :value="organisasi.kuota" />
                  </span>
                </v-list>
              </v-col>
            </v-row>
          </m-card>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      organisasi: {}
    }
  },
  methods: {
    open(obj) {
      if (obj) {
        this.dialog = true
        this.organisasi = {...obj}
        this.$refs.dlg.open()
      }
    }
  }
}
</script>
